//@ts-nocheck TS6133
/* eslint-disable @typescript-eslint/no-duplicate-imports */
import type * as Types from "owa-graph-schema";
import type { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type BootstrapQueryVariables = Types.Exact<{
    [key: string]: never;
}>;
export type BootstrapQuery = {
    __typename?: "Query";
    sample?: {
        __typename?: "SampleResult";
        id?: number | null;
    } | null;
};
export const BootstrapDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "bootstrap" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "sample" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }] } as unknown as DocumentNode<BootstrapQuery, BootstrapQueryVariables>;
